import { render } from "./addGoodsInfo.vue?vue&type=template&id=9ad25540&scoped=true"
import script from "./addGoodsInfo.vue?vue&type=script&lang=js"
export * from "./addGoodsInfo.vue?vue&type=script&lang=js"

import "./addGoodsInfo.vue?vue&type=style&index=0&id=9ad25540&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad25540"]])

export default __exports__